import { render } from "./SchedulesExpansion.vue?vue&type=template&id=ed80e46e&scoped=true"
import script from "./SchedulesExpansion.vue?vue&type=script&lang=js"
export * from "./SchedulesExpansion.vue?vue&type=script&lang=js"

import "./SchedulesExpansion.vue?vue&type=style&index=0&id=ed80e46e&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed80e46e"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
